package one.healthium.uscreen.ui.blocks

import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.platform.testTag
import one.healthium.ui.components.ReviewsPager
import one.healthium.uscreen.domain.models.ReviewCarouselBlock
import one.healthium.uscreen.ui.util.uscreenPadding

@Composable
fun UScreenReviewCarouselBlock(
    modifier: Modifier = Modifier,
    block: ReviewCarouselBlock,
) {
    ReviewsPager(
        modifier = modifier
            .fillMaxWidth()
            .uscreenPadding(block.padding)
            .testTag("uscreen_review_carousel"),
        reviews = block.reviews,
    )
}
